import { useUsers } from '../../../carrier/users/data/UsersAPI';
import { THIRTY_SECONDS } from 'shared/constants/NumberConstants';
import { BaseResourceFieldProps } from 'shared/form/ResourceFieldLegacy';
import { DispatcherDTO } from 'shared/modules/dispatcher/DispatcherDTO';
import { ResourceField } from 'shared/form/ResourceField';
import { useDispatcher } from './DispatcherAPI';

export function DispatcherField(props: BaseResourceFieldProps<DispatcherDTO>) {
  const useOptions = (q: string | undefined, options?: { enabled?: boolean }) =>
    useUsers(
      {
        q: !!q && q.length >= 3 ? q : '',
        role_in: 'office_staff,dispatching,accounting,operations',
        status: 'invited,activated,deactivated',
        ordering: 'name',
      },
      {
        enabled: options?.enabled ?? true,
        staleTime: THIRTY_SECONDS,
        refetchOnWindowFocus: false,
      },
    );

  const useSelectedOption = (guid: string) =>
    useDispatcher(guid, {
      staleTime: THIRTY_SECONDS,
      refetchOnWindowFocus: false,
    });

  return (
    <ResourceField
      {...props}
      useOptions={useOptions}
      noOptionsText="No dispatchers found"
      useSelectedOption={useSelectedOption}
      getOptionKey={(option) => {
        if ('office_staff' in option) {
          return option.office_staff?.guid || option.guid;
        }

        return option.guid;
      }}
      getOptionLabel={(option) => {
        if ('office_staff' in option) {
          return (
            option.internal_name ||
            option.name ||
            option.email ||
            option.phone_number
          );
        }

        return option.name || option.email;
      }}
    />
  );
}
